var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center mt-3",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          _vm.records && _vm.records.length
            ? [
                _c("table", { staticClass: "table table-hover table-sm" }, [
                  _c(
                    "tbody",
                    _vm._l(_vm.records, function (o, i) {
                      return _c("tr", [
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              i +
                                1 +
                                (_vm.paginator.current_page - 1) *
                                  _vm.paginator.per_page
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("p", [_vm._v(_vm._s(o.client_name))]),
                            _vm._v(" "),
                            _vm._l(o.search_phones, function (p) {
                              return [_c("p", [_vm._v(_vm._s(p))])]
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(o.order_data.order_id))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          _vm._l(o.order_data.drugs, function (d) {
                            return _c("p", [
                              _vm._v(_vm._s(d.title) + " x "),
                              _c("strong", [_vm._v(_vm._s(d.requestQty))]),
                              _vm._v(" x\n                "),
                              _c("strong", [_vm._v(_vm._s(d.price))]),
                            ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(o.price))]),
                        _vm._v(" "),
                        _c("td", [
                          _c("p", [
                            _vm._v(_vm._s(_vm.printDate(o.created_at))),
                          ]),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(o.catalog_order_id))]),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _vm.paginator
                ? _c("paginate", {
                    ref: "Pagination",
                    attrs: {
                      "page-count": _vm.paginator.last_page,
                      "page-range": 11,
                      "margin-pages": 2,
                      "click-handler": _vm.getRecords,
                      "prev-text": "&laquo",
                      "next-text": "&raquo",
                      "container-class": "pagination",
                      "prev-class": "page-item",
                      "prev-link-class": "page-link",
                      "page-class": "page-item",
                      "page-link-class": "page-link",
                      "next-class": "page-item",
                      "next-link-class": "page-link",
                      "active-class": "active green_btn",
                    },
                    model: {
                      value: _vm.paginator.current_page,
                      callback: function ($$v) {
                        _vm.$set(_vm.paginator, "current_page", $$v)
                      },
                      expression: "paginator.current_page",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }